import React, { useEffect, useState, useMemo } from "react";
import useApi from "../../hooks/useApi";
import useKeyboardNavigation from "../../hooks/useKeyboardNavigation";

const JobCodeList = ({ onClose, onSelect, BASE_URL, COMPANY_CODE }) => {
  const [jobs, setJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { request, loading } = useApi();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const url = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/JOBLIST/-/-`;
        const response = await request({
          url,
          method: "GET",
          timeout: 3000,
        });
        setJobs(response || []);
      } catch (err) {
        console.error("Failed to fetch job list", err);
        setJobs([]);
      }
    };

    fetchJobs();
  }, []);

  const handleRowClick = (job) => {
    if (onSelect) onSelect(job);
    if (onClose) onClose();
  };

  const filteredJobs = useMemo(() => {
    if (!searchTerm) return jobs;
    return jobs?.filter((job) =>
      [job.JobCode, job.Description, job.Site, job.Customer].some((field) =>
        field?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, jobs]);

  const { selectedIndex, rowRefs } = useKeyboardNavigation({
    list: filteredJobs,
    onEnter: (job) => handleRowClick(job),
    isActive: true,
    enableScroll: true,
  });

  return (
    <div className="p-5">
      <div className="mb-4">
        <input
          type="text"
          autoFocus
          placeholder="Search jobs..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition"
        />
      </div>

      <div
        tabIndex={0}
        onFocus={() => {}}
        className="max-h-[400px] overflow-y-auto rounded-lg shadow-lg border border-gray-200"
      >
        {loading ? (
          <div className="flex justify-center items-center p-6 text-gray-500">
            Loading jobs...
          </div>
        ) : filteredJobs.length === 0 ? (
          <div className="flex justify-center items-center p-6 text-gray-500">
            No jobs found
          </div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="sticky top-0 z-10">
              <tr className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-md rounded-t-lg">
                <th className="px-4 py-3 text-left font-semibold text-sm uppercase tracking-wide">
                  Job Code
                </th>
                <th className="px-4 py-3 text-left font-semibold text-sm uppercase tracking-wide">
                  Description
                </th>
                <th className="px-4 py-3 text-left font-semibold text-sm uppercase tracking-wide">
                  Site
                </th>
                <th className="px-4 py-3 text-left font-semibold text-sm uppercase tracking-wide">
                  Customer
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {filteredJobs?.map((job, idx) => (
                <tr
                  key={idx}
                  ref={rowRefs.current[idx]}
                  onClick={() => handleRowClick(job)}
                  className={`cursor-pointer transition-colors 
              ${selectedIndex === idx ? "bg-blue-100" : "hover:bg-blue-50"}
            `}
                >
                  <td className="px-4 py-2 text-sm text-gray-700">
                    {job.JobCode}
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-700">
                    {job.Description}
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-500">
                    {job.Site || "-"}
                  </td>
                  <td className="px-4 py-2 text-sm text-gray-700">
                    {job.Customer}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default JobCodeList;
